module.exports = __webpack_public_path__ + "kg.svg?a3bb66b0fc08b8ecb2fe304ad8e0ebc3";